module.exports = __webpack_public_path__ + "6cf1e7a4cc8b37a9cad0317c0a0eb1b5.svg";